<template>
  <KemudahanAsasBase :amenity="amenity" />
</template>

<script>
// Bekalan Elektrik — Peratusan isi rumah mengikut kemudahan bekalan elektrik.
// Sub-kategori: Kemudahan bekalan elektrik / Tiada bekalan elektrik (rujuk Lampiran 3).
// All UI, filters and export live in KemudahanAsasBase; this page supplies the config.
import KemudahanAsasBase from "./KemudahanAsasBase.vue";

export default {
  name: "BekalanElektrik",
  components: { KemudahanAsasBase },
  data() {
    return {
      amenity: {
        key: "elektrik",
        endpoint: "getBekalanElektrikLampiran",
        icon: "mdi-flash",
        title: "Bekalan Elektrik",
        subtitle: "Peratusan isi rumah mengikut kemudahan bekalan elektrik, strata dan daerah pentadbiran",
        cardTitle: "Peratusan Isi Rumah mengikut Bekalan Elektrik",
        exportTitle: "PERATUSAN ISI RUMAH MENGIKUT BEKALAN ELEKTRIK",
        subCategories: ["Kemudahan bekalan elektrik", "Tiada bekalan elektrik"],
        sheetName: "Bekalan Elektrik",
        fileSlug: "Peratusan_Isi_Rumah_Bekalan_Elektrik",
      },
    };
  },
};
</script>
